<template>
  <section class="studio-product">
    <template v-if="detail.spu">
      <van-tabs v-model="tabActive" :class="{ 'show-tabs': showTabs }" @scroll="handleScroll" scrollspy sticky>
        <van-tab title="商品">
          <div class="banner" v-if="detail.spu.banner_img">
            <van-swipe :show-indicators="false" width="100%" @change="stopBannerVideo">
              <van-swipe-item v-if="detail.spu.banner_video">
                <mall-video-player :src="detail.spu.banner_video" :poster="detail.spu.banner_video_cover" ref="bannerPlayer" />
              </van-swipe-item>
              <van-swipe-item v-for="(item, index) in detail.spu.banner_img" :key="index">
                <img :src="item | replaceUrlProtocol">
              </van-swipe-item>
            </van-swipe>
          </div>

          <div class="price-area">
            <div class="price-rmb">
              <span class="unit">¥</span>
              <strong class="rmb">{{ detail.spu.lowest_money }}</strong>
              <span v-if="detail.spu.sku_list.length > 1">起</span>
              <!-- <div class="price-original">
                ¥400
              </div> -->
            </div>
            <div class="coupon-info" @click="openCoupon" v-if="detail.discount.length" v-cbs="`coupon_click`">
              <ul>
                <li v-for="(item, index) in discount" :key="index">
                  {{ item.title }}
                </li>
              </ul>
              <div class="view">查看<van-icon name="arrow" /></div>
            </div>
            <div class="product-name">{{ detail.spu.description.desc }}</div>
            <div class="ensure-lists">
              {{ detail.spu.description.ensure }}
            </div>
          </div>

          <div class="specification">
            <div class="module-item classification" @click="openClass" v-cbs="`standards-choose_click`">
              <div class="hd">选择</div>
              <div class="bd">
                <div class="class-body">
                  <div class="text">
                    <span>
                      <template v-if="selectedSku.selectedSkuComb">
                        已选：{{ selectedValueName }}
                      </template>
                      <template v-else>
                        {{ unselectedName }}
                      </template>
                    </span>
                  </div>
                  <van-icon name="arrow" />
                </div>
                <ul class="class-list">
                  <li>{{ firstSpecName }}</li>
                  <li>{{ labelLength }}种分类可选</li>
                </ul>
              </div>
            </div>

            <div class="module-item">
              <div class="hd">说明</div>
              <div class="bd">
                <div class="text"><span>{{ detail.spu.description.info }}</span></div>
              </div>
            </div>

            <div class="module-item">
              <div class="hd">客服</div>
              <div class="bd">
                <img class="icon" src="~../images/icon-2.svg"> GoldMoon88888
              </div>
            </div>
          </div>
        </van-tab>

        <!-- <van-tab title="评价" /> -->

        <van-tab title="服务详情">
          <div class="product-detail">
            <h2>服务详情</h2>
            <div class="images">
              <img v-for="(item, index) in detail.spu.banner_img_detail" :key="index" :data-src="item | replaceUrlProtocol" class="lazyload">
            </div>
            <div class="bottom">已经到底了</div>
          </div>
        </van-tab>
      </van-tabs>

      <section class="footer">
        <div class="inner">
          <div class="action">
            <div class="home">
              <a href="javascript:;" class="btn" @click="goHome">首页</a>
            </div>
            <div class="buy">
              <button type="button" class="btn" @click="openClass">立即购买</button>
            </div>
          </div>
        </div>
      </section>

      <van-popup v-model="popupCoupon" class="popup-coupon" round closeable position="bottom" :style="{ height: '80%' }">
        <div class="coupon">
          <h3>优惠详情</h3>
          <ul>
            <li v-for="(item, index) in detail.discount" :key="index">
              <div class="name">活动优惠</div>
              <div class="hd">
                <template v-if="item.discount_type == 0">
                  <strong>{{ item.discount / 10 }}</strong>折
                </template>
                <template v-else-if="item.discount_type == 1">
                  ¥<strong>{{ item.cut_money }}</strong>
                </template>
              </div>
              <div class="bd">
                <h4><span>{{ item.title }}</span></h4>
                <p><span>活动时间：{{ item.start_time | format }}-{{ item.end_time | format }}</span></p>
              </div>
            </li>
            <!-- <li @click="takeCoupon">
              <div class="name">商品优惠券</div>
              <div class="hd">
                ¥<strong>20</strong>
              </div>
              <div class="bd">
                <h4><span>老用户回馈 唱作服务8折</span></h4>
                <p><span>活动时间：2020.12.07-2020.12.9</span></p>
              </div>
              <div class="ft">
                <div class="gap"></div>
                立即领取
              </div>
            </li>
            <li class="disabled" @click="takeCoupon">
              <div class="name">商品优惠券</div>
              <div class="hd">
                ¥<strong>20</strong>
              </div>
              <div class="bd">
                <h4><span>老用户回馈 唱作服务8折</span></h4>
                <p><span>活动时间：2020.12.07-2020.12.9</span></p>
              </div>
              <div class="ft">
                <div class="gap"></div>
                已领取
              </div>
            </li> -->
          </ul>
        </div>
      </van-popup>

      <van-sku
        v-model="popupClass"
        :sku="sku"
        :goods="{ picture: detail.spu.banner_img[0] }"
        :goods-id="detail.id"
        :hide-stock="true"
        :show-add-cart-btn="false"
        :preview-on-click-image="false"
        :disable-stepper-input="true"
        style="height: 70%;"
        class="popup-class"
        @buy-clicked="onBuyClicked"
        @sku-selected="onSkuSelected"
      >
        <template #sku-header-price="props">
          <div class="price">
            <strong><small>¥</small>{{ Number(props.price) }}</strong>
            <span v-if="detail.spu.sku_list.length > 1 && !selectedSku.selectedSkuComb">起</span>
            <!-- <s>¥400</s> -->
          </div>
        </template>
        <template #sku-stepper>
          <div class="hidden"></div>
        </template>
      </van-sku>
    </template>

    <mall-float-navigator v-show="false" ref="navigator" />
  </section>
</template>

<script>
import commonObj from 'commonObj';
import qs from 'qs';
import MallFloatNavigator from '@cdn_js/components/FloatNavigator';
import MallVideoPlayer from '../components/VideoPlayer';
import dayjs from 'dayjs';
import { track, trackElClickH5 } from '@changba/funny';

const maxScrollHeight = window.lib.flexible.rem2px(5.62);

export default {
  name: 'StudioProduct',

  components: {
    MallFloatNavigator,
    MallVideoPlayer
  },

  filters: {
    format(val) {
      return dayjs(val).format('YYYY.MM.DD');
    }
  },

  props: {
    id: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      detail: {},

      tabActive: 0,
      showTabs: false,
      tabOpacity: 0,

      popupCoupon: false,
      popupClass: false,

      sku: {
        tree: [],
        list: [],
        price: 0, // 默认价格（单位元）
        stock_num: 0, // 商品总库存
        none_sku: false // 是否无规格商品
      },

      selectedSku: {},
      skuNameMap: {},
      skuValueMap: {}
    }
  },

  computed: {
    isLogin() {
      return this.$curuserid && this.$token;
    },

    firstSpecName() {
      return this.detail.spu.labels[0].value[0].name;
    },

    // 已选择的规格值
    selectedValueName() {
      const names = [];

      this.detail.spu.labels.forEach((item, index) => {
        names.push(this.skuValueMap[this.selectedSku.selectedSkuComb[`s${index}`]]);
      });

      return names.join('/');
    },

    // 未选择的规格名
    unselectedName() {
      const names = [];

      this.detail.spu.labels.forEach((item, index) => {
        const id = `s${index}`;

        if (!this.selectedSku.selectedSku?.[id]) {
          names.push(this.skuNameMap[id]);
        }
      });

      return names.join('/');
    },

    // 规格分类总数
    labelLength() {
      let result = 0;

      this.detail.spu.labels.forEach((item) => {
        result += item.value.length;
      });

      return result;
    },

    discount() {
      return this.detail.discount.slice(0, 2);
    }
  },

  watch: {
    id() {
      this.refresh();
    }
  },

  created() {
    this.refresh();
  },

  methods: {
    async refresh() {
      this.$toast.loading();

      const { code, data } = await this.$fetch('/api/musicStore/musicmall/getSpuInfo', {
        data: {
          spuid: this.id
        }
      });

      this.$toast.clear();

      if (code === 1) {
        if (!data.spu) {
          this.$router.replace('/404');

          return;
        }

        this.detail = data;

        document.title = this.detail.spu.name;
        track('pageId', `${this.detail.spu.name}(${this.$options.name})`);

        if (this.detail.discount.length > 0) {
          trackElClickH5('coupon_show');
        }

        // 组织规格数据
        const tree = [];
        const list = [];
        let totalStock = 0;
        const nameMap = {};
        const valueMap = {};

        this.detail.spu.labels.forEach((item, index) => {
          const name = `s${index}`;

          tree.push({
            k: item.name,
            k_s: name,
            v: item.value
          });

          item.value.forEach(item => {
            valueMap[item.id] = item.name;
          });

          nameMap[name] = item.name;
        });

        this.skuNameMap = nameMap;
        this.skuValueMap = valueMap;

        this.detail.spu.sku_list.forEach((item) => {
          const stock = item.stock >= 0 ? item.stock : 99;
          const obj = {
            id: item.id,
            price: item.price * 100,
            stock_num: stock
          };

          totalStock += stock;

          item.attribute_value.forEach((item, index) => {
            obj[`s${index}`] = item;
          });

          list.push(obj);
        });

        this.sku.tree = tree;
        this.sku.list = list;
        this.sku.price = this.detail.spu.lowest_money;
        this.sku.stock_num = totalStock;
      }
      else {
        this.$router.replace('/404');
      }
    },

    stopBannerVideo() {
      this.$refs?.bannerPlayer?.stop?.();
      trackElClickH5('first-picture_click');
    },

    handleScroll({ scrollTop }) {
      if (scrollTop > maxScrollHeight) {
        this.showTabs = true;
      }
      else {
        this.showTabs = false;
      }
      // console.log(scrollTop, isFixed);
    },

    openClass() {
      this.popupClass = true;
    },

    openCoupon() {
      this.popupCoupon = true;
    },

    onBuyClicked(skuData) {
      trackElClickH5('buy_click');

      if (this.isLogin) {
        this.$router.push(`/studio/buy/${skuData.selectedSkuComb.id}`);
      }
      else {
        this.openApp(`/studio/product/${this.detail.id}`);
      }
    },

    onSkuSelected(skuData) {
      this.selectedSku = skuData;
    },

    takeCoupon() {
      console.log('领取优惠券');
    },

    openApp(uri, params) {
      let url = `${window.location.origin}${this.$router.options.base}${uri}`;
      const query = qs.stringify(params);

      if (query) {
        url += `?${query}`;
      }

      commonObj.utils.openApp(false, url);
    },

    goHome() {
      if (this.$refs.navigator.isMusicboard) {
        this.$refs.navigator.gotoMusicboard();
      }
      else {
        this.$router.push({
          path: '/',
          query: {
            star_userid: this.$route.query.star_userid
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../styles/product.scss";
</style>
